import React, { useState } from "react";
import MainLayout from "../../components/MainLayout/MainLayout";
import { BecomeAVendorWrapper } from "./component";
/** @jsxImportSource @emotion/react */
import "twin.macro";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Button, Input, Progress, Skeleton } from "antd";
import { ReactComponent as Pinmap } from "../../assets/svg/map-pin-white.svg";
import { ReactComponent as ArrowRight } from "../../assets/svg/Arrow-Right.svg";
import { active, AppButton, inputStyle } from "../../lib/styles/styleLibrary";
import { isEmpty, Toast } from "../../lib/helpers/helpers";
import { useMutation } from "react-query";
import { Loading, PageLoading, UploadImage } from "../../components";
import { useVendorCategory } from "../../redux/api/VendorHooks";
// import Geocode from "react-geocode";
import Auth from "../../lib/middleware/auth";
import {
	uploadVendorCoverPhoto,
	uploadVendorPortfolioImages,
} from "../../redux/actions/media";
import { createVendorStand } from "../../redux/actions/vendor";
import CurrencyFormat from "react-currency-format";
import { v4 } from "uuid";
import { ROUTES } from "../../settings/routes";
import { useHistory } from "react-router";

const BecomeAVendor = (props) => {
	const user = Auth.getUser();
	const history = useHistory();
	const [percentage, setPercentage] = useState(8);
	const [questions, setQuestions] = useState(1);
	const [subFlow, setSubFlow] = useState("about");
	const [coverPhoto, setCoverPhoto] = useState([]);
	const [portfolioImage, setPortfolioImage] = useState([]);

	const [fields, setFields] = useState({
		stand_location_address: "",
		description: "",
		categoryId: 1,
		stand_location_longitude: "",
		stand_location_latitude: "",
		min_price: "",
		max_price: "",
		phone: user?.phone,
		stand_name: "",
	});

	console.log(fields);

	// useEffect(() => {
	// 	Geocode.fromAddress("Eiffel Tower").then(
	// 		(response) => {
	// 			const { lat, lng } = response.results[0].geometry.location;
	// 			console.log(lat, lng);
	// 		},
	// 		(error) => {
	// 			console.error(error);
	// 		}
	// 	);
	// }, [fields.stand_location_address]);

	// handle Create stand
	const { mutateAsync: createStand, isLoading: createLoading } =
		useMutation(createVendorStand);

	const handleAbout = async (e) => {
		e.preventDefault();
		if (
			isEmpty(fields.stand_location_address) ||
			// isEmpty(fields.stand_location_latitude) ||
			// isEmpty(fields.stand_location_longitude) ||
			isEmpty(fields.min_price) ||
			isEmpty(fields.max_price) ||
			isEmpty(fields.description) ||
			isEmpty(fields.categoryId) ||
			isEmpty(fields.stand_name)
		) {
			Toast.fire({
				icon: "error",
				title: `All fields are required`,
			});
			return;
		}
		try {
			const response = await createStand(fields);
			console.log("\nCreate wedding res: =====>\n", response.data);
			const { hasError } = response.data;
			if (hasError) {
				Toast.fire({
					icon: "error",
					title: response.data.message,
				});
			}
			Toast.fire({
				icon: "success",
				title: `Account setup successfully`,
			});
			setSubFlow("image");
			handleAddPercent();
		} catch (err) {
			console.log("Error: ", err);
		}
	};

	const handleFinish = async (e) => {
		e.preventDefault();
		setTimeout(() => {
			history.push(ROUTES.DASHBOARD);
		}, 2000);
	};

	// console.log("\n ==========I am the wedding data=========\n", weddingData);
	const handlePrevious = () => {
		switch (subFlow) {
			case "image":
				setSubFlow("about");
				setQuestions(questions - 1);
				break;
			default:
				// props.goBack()
				break;
		}
	};

	// Setting up step counter for progressbar
	React.useEffect(() => {
		const totalQuestions = 2;
		const percent = (questions / totalQuestions) * 100;
		setPercentage(percent);
	}, [questions]);

	const handleAddPercent = () => {
		setQuestions(questions + 1);
	};

	const { TextArea } = Input;
	const { data: vendorCategories, isLoading: loadingCategories } =
		useVendorCategory();

	return (
		<MainLayout>
			<BecomeAVendorWrapper>
				<div tw="flex flex-row items-center justify-between gap-4 mb-2">
					<div tw="flex flex-row items-center gap-2 flex-nowrap">
						<ArrowLeftOutlined
							tw="p-3 bg-gray-100 rounded-full hover:bg-white"
							onClick={() => {
								handlePrevious();
							}}
						/>
						<h2 tw="m-0! font-bold text-2xl">
							{" "}
							Vendor Registration
						</h2>
					</div>
				</div>
				<div tw="w-full mb-8">
					<Progress
						strokeColor="black"
						percent={percentage}
						showInfo={false}
					/>
				</div>

				<div tw="flex flex-col justify-center" style={{ width: "75%" }}>
					{subFlow === "about" && (
						<div>
							<h4 tw="font-bold text-3xl opacity-50">
								What industry do you operate in?
							</h4>

							<div
								tw="mt-4 mb-4 flex flex-row flex-nowrap items-center gap-2 overflow-x-scroll"
								className="hide-scrollbar">
								{loadingCategories
									? Array.apply(null, Array(4)).map((i) => {
											return (
												<Skeleton.Button
													key={v4()}
													active={true}
													size={"large"}
													shape={"round"}
												/>
											);
									  })
									: vendorCategories?.map((cat, i) => {
											return (
												<Button
													key={i}
													onClick={() => {
														setFields({
															...fields,
															categoryId: cat.id,
														});
													}}
													css={
														cat.id ===
															fields.categoryId &&
														active
													}
													tw="rounded-2xl min-w-min text-white! bg-gray-400 inline-flex gap-2 border-none  items-center justify-center py-4 px-5 hover:(bg-appPinkSaturated text-white!) active:(bg-appPinkSaturated! text-white! text-xs font-medium shadow) focus:(bg-appPink text-white border-none)">
													<span tw="text-sm font-semibold">
														{cat?.title}
													</span>
												</Button>
											);
									  })}
							</div>

							<div tw="mt-4">
								<label htmlFor="name" className="label">
									Business Name
								</label>
								<div className="form-control">
									<Input
										placeholder="Enter business name"
										type="text"
										css={inputStyle}
										value={fields.stand_name}
										onChange={(e) =>
											setFields({
												...fields,
												stand_name: e.target.value,
											})
										}
										tw="w-full"
										prefix={
											<img src={user} alt="" tw="pr-2" />
										}
									/>
								</div>
							</div>

							<div tw="mt-6">
								<label htmlFor="name" className="label">
									Business Location
								</label>
								<div className="form-control">
									<Input
										placeholder="Location"
										type="text"
										css={inputStyle}
										value={fields.stand_location_address}
										onChange={(e) =>
											setFields({
												...fields,
												stand_location_address:
													e.target.value,
											})
										}
										tw="w-full"
										prefix={<Pinmap tw="p-0.5" />}
									/>
								</div>
							</div>

							<div tw="mt-6">
								<label htmlFor="name" className="label">
									Price Range (N)
								</label>
								<div className="form-control" tw="w-full">
									<CurrencyFormat
										value={fields.min_price}
										allowNegative={false}
										displayType={"input"}
										thousandSeparator={true}
										placeholder={"Minimum Price"}
										type="tel"
										css={inputStyle}
										fixedDecimalScale={true}
										onValueChange={(values) => {
											const { value } = values;
											setFields({
												...fields,
												min_price: value,
											});
										}}
										prefix={"₦"}
										tw="w-full m-0! text-sm!"
									/>
									<ArrowRight tw="flex items-center h-8 w-16" />
									<CurrencyFormat
										value={fields.max_price}
										allowNegative={false}
										displayType={"input"}
										thousandSeparator={true}
										placeholder={"Maximum Price"}
										type="tel"
										css={inputStyle}
										fixedDecimalScale={true}
										onValueChange={(values) => {
											const { value } = values;
											setFields({
												...fields,
												max_price: value,
											});
										}}
										prefix={"₦"}
										tw="w-full m-0! text-sm!"
									/>
								</div>
							</div>

							<div tw="mt-6">
								<label htmlFor="name" className="label">
									Business Description
								</label>
								<div className="form-control">
									<TextArea
										placeholder="Tell us a bit about your business"
										type="text"
										css={inputStyle}
										rows={4}
										value={fields.description}
										onChange={(e) =>
											setFields({
												...fields,
												description: e.target.value,
											})
										}
										tw="w-full text-sm!"
									/>
								</div>
							</div>

							<div tw="mt-20 mb-8">
								<AppButton onClick={handleAbout}>
									{createLoading ? <Loading /> : "Next"}
								</AppButton>
							</div>
							{/* </form> */}
						</div>
					)}

					{subFlow === "image" && (
						<div tw="mb-8">
							<div>
								<label htmlFor="name" className="label">
									Upload cover photo
								</label>
								<div tw="mt-4 mb-8 w-full! flex flex-col justify-center items-center gap-2 flex-wrap h-full!">
									<UploadImage
										setImageUrlList={setCoverPhoto}
										imageUrlList={coverPhoto}
										uploadAPI={uploadVendorCoverPhoto}
										uploadText={
											<span tw="text-appPink">
												Cover Photo
											</span>
										}
										maxCount={1}
										buttonContentDirection={"row-reverse"}
										buttonWidth={"100%"}
										credentials={user?.vendorId}
										tw="h-20"
									/>
								</div>

								<div tw="flex flex-col gap-4 h-auto">
									<label htmlFor="name" className="label">
										Upload portfolio images
									</label>
									<UploadImage
										setImageUrlList={setPortfolioImage}
										imageUrlList={portfolioImage}
										uploadAPI={uploadVendorPortfolioImages}
										multiple
										maxCount={8}
										buttonContentDirection={"row"}
										buttonWidth={"100%"}
										tw="border-none! p-0! m-0! h-auto!"
										noUploadText
										noBorder
										credentials={user?.vendorId}
									/>
								</div>
							</div>

							<div tw="mt-16">
								<AppButton tw="" onClick={handleFinish}>
									Submit for review
								</AppButton>
							</div>
						</div>
					)}
				</div>

				{createLoading && <PageLoading />}
			</BecomeAVendorWrapper>
		</MainLayout>
	);
};

export default BecomeAVendor;
